<template>
  <div class="dimmed">
    <div v-if="!isFailed" class="rendering--wrap ing" :class="{rendering: isProcessing}">
      <div v-if="isWaiting">
        <i class="icon icon--renderer-waiting"></i>
        <p class="desc">{{ $t('page.renderingLayer.waiting.desc') }}</p>
      </div>
      <div v-if="isProcessing">
        <i class="icon icon--rendering"></i>
        <p class="desc">{{ $t('page.renderingLayer.processing.desc') }}</p>
      </div>
      <div class="loading--wrap">
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
        <i class='loading-bar'></i>
      </div>
      <div class="queue--wrap" v-if="isWaiting">
        <div class="info">
          <p v-html="waitCountHtml"></p>
          <span class="current-date">{{ nowDateStr }}</span>
        </div>
      </div>
      <div class="tip--wrap">
        <i class="text-tip">{{ $t('common.tip') }} !</i>
        <div class="swiper-container">
          <div class="swiper-wrapper"
               :class="{isDragging}"
               :style="{left: slidePosition}"
               ref="slides"
               @mousedown="onHandleStart"
               @touchstart="onHandleStart"
          >
            <div class="list1 swiper-slide screen-shot">
              <div class="content--wrap">
                <div class="question">
                  <i class="icon icon--user"></i>
                  <div class="text--wrap">
                    <p>{{ $t('page.renderingLayer.tip.list1.q') }}</p>
                  </div>
                </div>
                <div class="answer">
                  <div class="text--wrap">
                    <p>
                      <span v-html="$t('page.renderingLayer.tip.list1.a1')"></span><br>
                      <span v-html="$t('page.renderingLayer.tip.list1.a2')"></span>
                    </p>
                    <figure></figure>
                  </div>
                  <i class="icon icon--logo-mini"></i>
                </div>
              </div>
            </div>
<!--            <swiper-slide class="list2">-->
<!--              <div class="content&#45;&#45;wrap">-->
<!--                <div class="question">-->
<!--                  <i class="icon icon&#45;&#45;user"></i>-->
<!--                  <div class="text&#45;&#45;wrap">-->
<!--                    <p>{{ $t('page.renderingLayer.tip.list2.q') }}</p>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="answer">-->
<!--                  <div class="text&#45;&#45;wrap">-->
<!--                    <p>-->
<!--                      <span v-html="$t('page.renderingLayer.tip.list2.a1')"></span><br>-->
<!--                      <span v-html="$t('page.renderingLayer.tip.list2.a2')"></span>-->
<!--                    </p>-->
<!--                    <figure></figure>-->
<!--                  </div>-->
<!--                  <i class="icon icon&#45;&#45;logo-mini"></i>-->
<!--                </div>-->
<!--              </div>-->
<!--            </swiper-slide>-->
          </div>
<!--          <div class="swiper-pagination" slot="pagination" ref="pagination">-->
<!--            <template v-for="index in slides.length">-->
<!--              <span-->
<!--                :key="index"-->
<!--                class="dot"-->
<!--                :class="{ active: index - 1 === currentIndex }"-->
<!--                @click="goToSlide(index - 1)"-->
<!--              ></span>-->
<!--            </template>-->
<!--          </div>-->
<!--          <div v-show="!isFirstSlide"-->
<!--               ref="swiperLeft"-->
<!--               class="swiper-button-prev icon icon&#45;&#45;prev-gray-size20 step1"-->
<!--               @click="prevSlide"-->
<!--          ></div>-->
<!--          <div v-show="!isLastSlide"-->
<!--               ref="swiperRight"-->
<!--               class="swiper-button-next icon icon&#45;&#45;prev-gray-size20 step1"-->
<!--               @click="nextSlide"-->
<!--          ></div>-->
        </div>
      </div>
      <button @click="$emit('closeLayer')" class="btn__cancel">{{ $t('common.cancel') }}</button>
    </div>

    <div class="rendering--wrap failure" v-else>
      <div>
        <i class="icon icon--rendering-fail-size70"></i>
        <p v-if="taskCount === failedCount" class="title">{{ $t('page.renderingLayer.fail.title.all') }}</p>
        <p v-else class="title">{{ $t('page.renderingLayer.fail.title.part') }}</p>
      </div>
      <div class="desc--wrap">
        <p v-html="$t('page.renderingLayer.fail.desc')"></p><br>
        <p>{{ $t('page.renderingLayer.fail.desc2') }}</p>
      </div>
      <div class="info--wrap">
        <p class="info-title">
          <i class="icon icon--info-white-size17"></i>
          <strong>{{ $t('page.renderingLayer.fail.info.title') }}</strong>
        </p>
        <p class="info-desc" v-html="$t('page.renderingLayer.fail.info.desc')"></p>
      </div>
      <button class="btn__confirm"
        @click="$emit('onCaptureDone')">{{ $t('common.confirm') }}</button>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import { CAPTURE_STATE } from '@/libs/apply-helper'

export default {
  props: [
    'captureResult',
    'captureState'
  ],
  data () {
    return {
      showWaitingState: false,
      swiperLayoutWidth: 560,
      nowDateStr: null,
      waitCount: null,
      slides: [],
      currentIndex: 0,
      isDragging: false,
      startX: 0,
      endX: 0,
      dragOffset: 0,
      slidePosition: null
    }
  },
  computed: {
    isWaiting () {
      return this.captureState === CAPTURE_STATE.waiting
    },
    isProcessing () {
      return this.captureState === CAPTURE_STATE.processing
    },
    isDone () {
      return this.captureState === CAPTURE_STATE.done
    },
    isFailed () {
      return this.captureState === CAPTURE_STATE.failed
    },
    taskCount () {
      return this.captureResult.tasks.length
    },
    failedCount () {
      return this.captureResult.tasks.filter(item => item.statusCode < 0).length
    },
    waitCountHtml () {
      if (this.waitCount !== null) {
        return this.$t('page.renderingLayer.waiting.waitCount', { waitCount: this.waitCount })
      } else {
        return this.$t('page.renderingLayer.waiting.noWaitCount')
      }
    },
    isFirstSlide () {
      return this.currentIndex === 0
    },
    isLastSlide () {
      if (this.slides) {
        return this.currentIndex === this.slides.length - 1
      }
      return false
    }
  },
  watch: {
    captureResult (value) {
      if (value) {
        this.waitCount = value.waitCount
        this.nowDateStr = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
      }
    }
  },
  created () {
    this.CAPTURE_STATE = CAPTURE_STATE
  },
  mounted () {
    this.slides = document.querySelectorAll('.swiper-slide.screen-shot')

    this.getTransformStyle()
  },
  methods: {
    nextSlide () {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length
      this.getTransformStyle()
    },
    prevSlide () {
      this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length
      this.getTransformStyle()
    },
    goToSlide (index) {
      this.currentIndex = index
      this.getTransformStyle()
    },
    onHandleStart (event) {
      this.isDragging = true
      this.startX = event.touches ? event.touches[0].clientX : event.clientX
      this.dragOffset = 0
      if (this.isDragging) {
        window.addEventListener('mousemove', this.onHandleMove)
        window.addEventListener('mouseup', this.onHandleEnd)
      }
    },
    onHandleMove (event) {
      if (!this.isDragging) return

      const currentX = event.touches ? event.touches[0].clientX : event.clientX
      this.dragOffset = currentX - this.startX
      const dragTranslate = (this.dragOffset / 558) * 100
      const baseTranslate = -this.currentIndex * 100
      this.slidePosition = `${baseTranslate + dragTranslate}%`
    },
    onHandleEnd () {
      if (!this.isDragging) return

      if (this.slides.length > 1) {
        if (this.dragOffset > 50) {
          this.prevSlide()
        } else if (this.dragOffset < -50) {
          this.nextSlide()
        } else {
          this.resetDrag()
        }
        this.isDragging = false
        this.startX = 0
        this.endX = 0
        this.getTransformStyle()
      } else {
        this.isDragging = false
        this.slidePosition = '0%'
      }
    },
    getTransformStyle () {
      const baseTranslate = -this.currentIndex * 100
      const dragTranslate = (this.endX / 558) * 100
      this.slidePosition = `${baseTranslate + dragTranslate}%`
    },
    resetDrag () {
      this.dragOffset = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.rendering--wrap {
  width: 600px;
  border-radius: 14px;
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding-top: 50px;
  padding-bottom: 25px;
  text-align: center;
  @include positionXYcenter;

  &.ing {
    .swiper-container {
      height: 100%;

      /deep/ .swiper-wrapper {
        position: relative;
        white-space: nowrap;
        height: 100%;
        transition: left 0.3s ease;

        &.isDragging {
          transition: initial;
        }
      }
      .swiper-slide {
        position: relative;
        display: inline-block;
        vertical-align: top;
        height: 100%;
        width: 100%;

        & > div {
          @include positionYcenter;
          width: 100%;
          padding: 0 40px;
          box-sizing: border-box;
        }
      }
    }

    &.rendering {
      .desc {
        color: $brandColor;
      }
      .loading--wrap {
        .loading-bar {
          background-color: $brandColor;
        }
      }
      .queue--wrap {
        display: none;
      }
      .tip--wrap {
        margin-top: 80px;
      }
    }

    .desc {
      margin-top: 10px;
      font-size: 20px;
      font-weight: 600;
      text-align: center;
      color: #444444;
    }

    .loading--wrap {
      width: 180px;
      height: 12px;
      margin: 20px auto 0;

      .loading-bar {
        display: block;
        position: absolute;
        padding: 6px;
        border-radius: 50%;
        background-color: #43b6c9;
        animation: loading 1.4s ease-in-out 0s infinite;

        &:nth-child(1) {
          animation-delay: 0s;
        }
        &:nth-child(2) {
          animation-delay: 0.15s;
        }
        &:nth-child(3) {
          animation-delay: 0.3s;
        }
        &:nth-child(4) {
          animation-delay: 0.45s;
        }
        &:nth-child(5) {
          animation-delay: 0.6s;
        }
      }
    }

    .queue--wrap {
      margin-top: 24px;

      .btn__check-queue {
        position: relative;
        min-width: 138px;
        padding-left: 12px;
        padding-right: 12px;
        height: 38px;
        border-radius: 20px;
        background-color: $brandColor;

        font-size: 14px;
        font-weight: 600;
        text-align: right;
        color: #ffffff;
        i {
          @include positionYcenter;
          left: 12px;
        }
        span {
          margin-left: 30px;
        }
      }

      .info {
        font-weight: 600;
        line-height: 21px;
        p {
          font-size: 14px;
          color: #444444;
          span {
            color: $brandColor;
          }
        }
        .current-date {
          color: #666666;
        }
      }
    }

    .tip--wrap {
      position: relative;
      margin: 20px auto 0;
      /*padding-left: 40px;*/
      /*padding-right: 40px;*/
      box-sizing: border-box;
      width: 560px;
      height: 290px;
      border-radius: 8px;
      border: solid 1px #d7d7d7;
      background-color: #ebebeb;
      overflow: hidden;

      .swiper-pagination {
        width: 100%;
        left: 0;
        bottom: 10px;

        position: absolute;
        text-align: center;
        transition: opacity .3s;
        transform: translateZ(0);
        z-index: 10;

        .swiper-pagination-bullet {
          margin: 0 4px;
          width: 8px;
          height: 8px;
          display: inline-block;
          border-radius: 100%;
          background-color: #666666;
          cursor: pointer;

          &.swiper-pagination-bullet-active {
            background-color: #ffffff;
          }
        }
      }
      .swiper-button-next, .swiper-button-prev {
        @include positionYcenter;
        z-index: 10;
        cursor: pointer;
        padding: 10px;
        background-position: center;
      }
      .swiper-button-prev {
        left: 0px;
        right: auto;
      }
      .swiper-button-next {
        right: 0px;
        left: auto;
        transform: rotate(180deg) translateY(50%);
      }

      i.text-tip {
        display: inline-block;
        width: 37px;
        height: 20px;
        line-height: 22px;
        border-radius: 4px;
        background-color: #43b6c9;

        font-size: 12px;
        font-weight: 600;
        color: #ffffff;

        position: absolute;
        top: 8px;
        left: 8px;
      }

      .text--wrap {
        display: inline-block;
        font-size: 13px;
        font-weight: 600;
        box-shadow: 0 7px 6px -4px rgba(0, 0, 0, 0.08), 0 0 1px 0 rgba(0, 0, 0, 0.3);
        border-radius: 16px;
      }

      .question {
        text-align: left;

        .icon {
          width: 32px;
          height: 32px;
          background-color: #fff;
          background-position: center;
          border-radius: 11px;
          box-shadow: 0 7px 6px -4px rgba(0, 0, 0, 0.08), 0 0 1px 0 rgba(0, 0, 0, 0.3);
          vertical-align: top;
          margin: 0;
          margin-right: 8px;
        }
        .text--wrap {
          color: #2f2f2f;
          background-color: #ffffff;
          border-top-left-radius: 0;
          height: 35px;
          line-height: 35px;
          padding-left: 15px;
          padding-right: 17px;
        }
      }

      .answer {
        text-align: right;
        margin-top: 20px;

        .icon {
          width: 32px;
          height: 32px;
          border-radius: 11px;
          box-shadow: 0 7px 6px -4px rgba(0, 0, 0, 0.08), 0 0 1px 0 rgba(0, 0, 0, 0.3);
          background-color: #ffffff;
          background-position: center;
          vertical-align: top;
          margin-left: 8px;
        }
        .text--wrap {
          background-color: #554d50;
          font-size: 13px;
          font-weight: 600;
          line-height: 1.54;
          color: #ffffff;
          border-top-right-radius: 0;
          padding-top: 20px;
          padding-left: 24px;
          padding-bottom: 22px;
          padding-right: 145px;
          position: relative;

          p {
            text-align: left;
            display: inline-block;
            span {
              display: inline-block;
              &:nth-last-of-type(1) {
                margin-top: 12px;
              }
            }
          }

          figure {
            display: inline-block;
            width: 102px;
            height: 102px;
            border-radius: 8px;
            @include positionYcenter;
            right: 15px;

            background-image: url(../../assets/img/page/rendering_tip_1.png);
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }
    }

    .btn__cancel {
      margin-top: 25px;

      padding-left: 12px;
      padding-right: 12px;
      min-width: 86px;
      height: 38px;
      border-radius: 20px;
      border: solid 1px #bbbbbb;
      background-color: #ffffff;

      font-size: 14px;
      font-weight: 600;
      line-height: 1;
      color: #444444;

      &:hover {
        @include hoverStyle;
      }
    }
  }

  &.failure {
    box-sizing: border-box;
    padding-left: 20px;
    padding-right: 20px;
    .title {
      margin-top: 10px;
      font-size: 20px;
      font-weight: 600;
      text-align: center;
      color: #444444;
    }
    .desc--wrap {
      position: relative;
      margin-top: 36px;
      padding-top: 31px;
      color: #444;
      font-size: 15px;
      font-weight: 600;
      line-height: 1.47;

      &:before {
        display: inline-block;
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100px;
        height: 1px;
        border-top: 1px solid #d7d7d7;
      }
    }
    .info--wrap {
      padding: 25px;
      box-sizing: border-box;
      width: 100%;
      border-radius: 8px;
      border: solid 1px #d7d7d7;
      background-color: #ebebeb;
      margin-top: 30px;
      text-align: left;

      .info-title {
        font-size: 14px;
        font-weight: 600;
        line-height: 1;
        color: #1199af;

        .icon {
          vertical-align: sub;
          margin-right: 5px;
        }
      }
      .info-desc {
        margin-top: 15px;
        font-size: 13px;
        font-weight: 600;
        line-height: 1.54;
        color: #2f2f2f;
        b {
          color: #1199af;
        }
      }
    }
    .btn__confirm {
      @include buttonTypeNormal;
      border: solid 1px #bbbbbb;
      background-color: #ffffff;
      font-size: 14px;
      font-weight: 600;
      color: #444444;
      margin-top: 25px;

      &:hover {
        @include hoverStyle;
      }
    }
  }
}

@keyframes loading {
  0% {
    transform: translateX(-15px);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(180px);
    opacity: 0;
  }
}

@-webkit-keyframes loading {
  0% {
    transform: translateX(-15px);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(180px);
    opacity: 0;
  }
}
</style>
